import cn from "classnames";
import Styles from "./WinnerArrow.module.scss";
import { Icon } from "../Icon/Icon";

export const WinnerArrow = ({
  show = true,
  points,
  className,
}: {
  points: "left" | "right";
  show?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        {
          [Styles.hidden]: !show,
          [Styles.left]: points === "left",
        },
        className,
        Styles.wrapper
      )}
    >
      <Icon type="winnerArrow" />
    </div>
  );
};
